module.exports = __webpack_public_path__ + "static/media/Concrete_1.1680ed04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/textures/Concrete_1.jpg
// module id = 1129
// module chunks = 0